import { PhotosApi } from '@/shared/api'
import {
  Photo,
  PhotoUploadLimit,
  CreatePhotoRequest,
  UpdatePhotoRequest,
  PhotosResponse,
  PhotoResponse,
  PhotoUrlResponse
} from '@/shared/api'

// Photo service class
export class PhotoService {
  private photosApi: PhotosApi

  constructor(getAuthToken: () => Promise<string | null>) {
    this.photosApi = new PhotosApi(getAuthToken)
  }

  // Get all photos for a trip
  async getPhotosByTrip(tripId: string): Promise<Photo[]> {
    const response = await this.photosApi.getPhotosByTrip(tripId)
    return response.photos
  }

  // Get photo upload limit for a trip
  async getPhotoUploadLimit(tripId: string): Promise<PhotoUploadLimit> {
    return await this.photosApi.getPhotoUploadLimit(tripId)
  }

  // Upload a new photo
  async createPhoto(tripId: string, photoData: CreatePhotoRequest): Promise<Photo> {
    const response = await this.photosApi.createPhoto(tripId, photoData)
    return response.photo
  }

  // Update photo metadata
  async updatePhoto(photoId: string, updateData: UpdatePhotoRequest): Promise<Photo> {
    const response = await this.photosApi.updatePhoto(photoId, updateData)
    return response.photo
  }

  // Delete a photo
  async deletePhoto(photoId: string): Promise<void> {
    await this.photosApi.deletePhoto(photoId)
  }

  // Get photo URL
  async getPhotoUrl(photoId: string): Promise<string> {
    const response = await this.photosApi.getPhotoUrl(photoId)
    return response.url
  }
}
